import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

export interface IItemColapsar {
  opened?: boolean,
  group?: string,
  linkHref?: string;
  linkTitle?: string;
  linkTarget?: string;
  linkRel?: string;

  titleTag?: string;
  titleText?: string; //borrar
  tituloTexto?: string;

  iconOpened?: string;
  iconClosed?: string;

  content?: string; //borrar
  contenido?: string;
}
@Component({
  selector: 'neo-colapsar',
  templateUrl: './colapsar.component.html',
  styleUrls: ['./colapsar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0px' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ColapsarComponent implements OnInit {

  @Input() elementos: IItemColapsar[] = [];
  @Input() itemInicialActivo: Number = null;

  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void { }

  collapseToggle(event, elemento, indice) {
    // console.log('Elemento ..', event.target, event.target.id);
    let collapse = event.target.closest('.collapse');
    let group = collapse.getAttribute('data-group');
    let indiceElemento = collapse.getAttribute('indice');
    let indiceActivo = null;
    let active: HTMLElement = this.element.nativeElement.querySelector(
      '.collapse-on[data-group="' + group + '"]'
    );
    if (active) {
      indiceActivo = active.getAttribute('indice');
    }
    console.log(' indiceElemento ', indiceElemento);
    console.log(' indiceActivo ', indiceActivo);
    if (group != '') {
      if (active && active?.classList) {
        if (active?.classList?.contains('collapse-on')) {
          this.renderer.removeClass(active, 'collapse-on');
        }
      }

      if (collapse.classList.contains('collapse-on')) {

        this.renderer.removeClass(collapse, 'collapse-on');

      } else {
        this.renderer.addClass(collapse, 'collapse-on');
      }

      if (indiceActivo == indiceElemento) {
        if (collapse.classList.contains('collapse-on')) {

          this.renderer.removeClass(collapse, 'collapse-on');

        }
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.itemInicialActivo && this.itemInicialActivo > 0) {
        this.focusItem();
      }
    }, 600)

  }


  focusItem() {
    const div = this.element.nativeElement.querySelector('[class*="collapse-on"]');
    console.log(div);
    if (div) {
      div.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start', alignToTop: true });
    }
  }


}
